import React from "react";
import "./Featured.css";
import { useTranslation } from "react-i18next";

const Featured = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="featured background" style={{ paddingTop: "70px" }}>
        <div className="container">
          <div className="row">
            {/* Left Image */}
            <div className="col-lg-6">
              <img
                alt=""
                src="../images/website1.png"
                style={{ width: "100%", height: "96%" }}
              />
            </div>

            {/* Right Content */}
            <div className="col-lg-6">
              <div className="center5">
                <h1 style={{ marginBottom: "20px", fontWeight: "600" }}>
                  {t("featured_title")}
                </h1>
              </div>

              <p className="testcolor2">{t("featured_desc")}</p>

              {/* Points */}
              <div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="box" style={{ marginBottom: "15px" }}>
                      <div className="icon11">
                        <span className="fa fa-lightbulb"></span>
                      </div>
                      <br />
                      <h5 style={{ textAlign: "left" }}>
                        {t("featured_point1")}
                      </h5>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="box" style={{ marginBottom: "15px" }}>
                      <div className="icon12">
                        <span className="fa fa-dollar"></span>
                      </div>
                      <br />
                      <h5 style={{ textAlign: "left" }}>
                        {t("featured_point2")}
                      </h5>
                    </div>
                  </div>
                </div>

                <div className="row" style={{ marginBottom: "15px" }}>
                  <div className="col-lg-6">
                    <div className="box" style={{ marginBottom: "15px" }}>
                      <div className="icon13">
                        <span className="fa fa-bullhorn"></span>
                      </div>
                      <br />
                      <h5 style={{ textAlign: "left" }}>
                        {t("featured_point3")}
                      </h5>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="box">
                      <div className="icon14">
                        <span className="fa fa-handshake"></span>
                      </div>
                      <br />
                      <h5 style={{ textAlign: "left" }}>
                        {t("featured_point4")}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Featured;
